<template>
  <div class="field-comparison">
    <field-comparison-label :field="field" :diff-type="diffType" />
    <field-comparison-diff
      :left="left"
      :right="right"
      :diff-type="diffType"
      :score="score"
      :expandable="expandable"
    />
  </div>
</template>

<script>
import FieldComparisonLabel from './FieldComparisonLabel';
import FieldComparisonDiff from './FieldComparisonDiff';

export default {
  name: 'FieldComparison',
  components: {
    FieldComparisonLabel,
    FieldComparisonDiff,
  },
  props: {
    field: {
      type: String,
      required: true,
    },
    left: {
      type: [String, Number],
      default: null,
    },
    right: {
      type: [String, Number],
      default: null,
    },
    diffType: {
      type: String,
      required: true,
    },
    score: {
      type: Number,
      default: null,
    },
    expandable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.field-comparison {
  display: grid;
  grid-template-columns: 1fr 6fr;
}
</style>
